export default __webpack_public_path__ + "static/media/duet_banner.31d54fb7.jpeg";